import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ChipType = 'existing' | 'extension' | null;

@Injectable({
  providedIn: 'root',
})
export class StatusChipService {
  constructor() {}

  private typeSubject = new BehaviorSubject<ChipType>(null);
  public type$ = this.typeSubject.asObservable();

  setType(type: ChipType) {
    this.typeSubject.next(type);
  }
}
